import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import {issueAttributesType} from '../../constants/proptype-validation';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import {sortAlphabeticallyByPath} from '../../utils/sortingHelpers';
import SelectBoxAdapter from '../common/SelectBoxAdapter';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import OverflowTooltip from '@adsk/bim360-matrix-react-overflow-tooltip';

class CustomRootCauseInlineEdit extends PureComponent {
  getOptions(currentRootCauseId) {
    const {activeIssueRootCausesGroupedDropdownOptions, rootCauseEntitiesMap} = this.props;
    const allOptions = activeIssueRootCausesGroupedDropdownOptions.reduce((arr, group) => arr.concat(group[1]), []);
    const currentOption = allOptions.find(option => option.id === currentRootCauseId);
    if (!currentOption && activeIssueRootCausesGroupedDropdownOptions.length) {
      // If current option is inactive - we still need to show it.
      const optionToAdd = rootCauseEntitiesMap[currentRootCauseId];
      if (optionToAdd) {
        const category = rootCauseEntitiesMap[optionToAdd.parentId];
        if (category) {
          const groupOptions = activeIssueRootCausesGroupedDropdownOptions.find(group => group[0] === category.title);
          const newGroup = [category.title];
          if (groupOptions) {
            newGroup.push(sortAlphabeticallyByPath([...groupOptions[1], optionToAdd], 'title'));
            return activeIssueRootCausesGroupedDropdownOptions.map(group =>
              group[0] === category.title ? newGroup : group
            );
          } else {
            newGroup.push([optionToAdd]);
            return sortAlphabeticallyByPath([...activeIssueRootCausesGroupedDropdownOptions, newGroup], '[0]');
          }
        }
      }
    }
    return activeIssueRootCausesGroupedDropdownOptions;
  }

  render() {
    const {
      issue,
      rootCauseEntitiesMap,
      className,
      styleType,
      activeIssueRootCausesGroupedDropdownOptions,
      isRequired,
      container
    } = this.props;
    const textNoAvailableRootCause = activeIssueRootCausesGroupedDropdownOptions.length
      ? undefined
      : i18n.t('new.noAvailableRootCauses');
    return (
      <IssueFieldInlineEdit
        issue={issue}
        attributeName={ISSUE_ATTRIBUTE_NAMES.ROOT_CAUSE_ID}
        label={i18n.t('new.rootCause')}
        placeholder={i18n.t('unspecifiedValue')}
        getDisplayValue={currentValue => {
          const selectedOption = rootCauseEntitiesMap[currentValue];
          return selectedOption ? (
            <OverflowTooltip autoTipOnEllipsis place={Tooltip.Places.BOTTOM} container={container}>
              {selectedOption.title}
            </OverflowTooltip>
          ) : (
            ''
          );
        }}
        className={className}
        data-testid="CustomRootCauseInlineEdit"
        styleType={styleType}
        multiline={false}
      >
        {(currentValue, closeEditMode, updateIssue) => (
          <SelectBoxAdapter
            selectedOptions={rootCauseEntitiesMap[currentValue]}
            autofocus
            options={this.getOptions(currentValue)}
            labelKey="title"
            valueKey="id"
            dropdownMaxWidth={275}
            grouped
            searchable
            searchIcon
            searchPlaceholder={i18n.t('filter.rootCauseSearchPlaceholder')}
            noResultsValue={textNoAvailableRootCause}
            onClose={closeEditMode}
            onChange={option => {
              updateIssue(option && option.id);
            }}
            clearable={!isRequired}
          />
        )}
      </IssueFieldInlineEdit>
    );
  }
}

CustomRootCauseInlineEdit.displayName = 'CustomRootCauseInlineEdit';

CustomRootCauseInlineEdit.propTypes = {
  issue: issueAttributesType.isRequired,
  activeIssueRootCausesGroupedDropdownOptions: PropTypes.array,
  rootCauseEntitiesMap: PropTypes.object,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  isRequired: PropTypes.bool,
  container: PropTypes.object
};

export default CustomRootCauseInlineEdit;
